module.exports = __webpack_public_path__ + "media/images/img_icon_04-e2be71842bc5686d546e5c50cdc37932.png";